module.exports = __webpack_public_path__ + "static/media/dxc.2f4fa6af.jpg";